import React from 'react';
import Text from '../../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './WorkplaceMemberDetailItem.module.scss';

interface Props {
	title?: string;
	children: React.ReactNode | React.ReactNode[];
}

const WorkplaceMemberDetailItem: React.FC<Props> = ({ title, children }) => {
	return (
		<div className={styles.wrapper}>
			{title && <Text tx={title} className={styles.title} />}
			{children}
		</div>
	);
};

export default WorkplaceMemberDetailItem;
